'use client';

import React from 'react';

import { Accordion, Typography } from 'lighthouse';

import { FAQS } from '@/constants/downloadApp';

import classes from '../../index.module.css';
import { useRevealGroup } from '../hooks';

const Faq = () => {
    const groupRef = useRevealGroup<HTMLElement>(classes.revealVisible);

    return (
        <section ref={groupRef} className='bg-white px-4 py-16 md:py-24' aria-labelledby='download-app-faq-title'>
            <div className='desktop-width md:px-8'>
                <div className='mx-auto mb-10 max-w-2xl text-center'>
                    <span
                        data-reveal
                        className={`${classes.reveal} mb-3 inline-block rounded-lg bg-primary/10 px-4 py-1.5 text-xs font-bold text-secondary`}>
                        سوالات پرتکرار
                    </span>
                    <h2
                        id='download-app-faq-title'
                        data-reveal
                        className={`${classes.reveal} text-2xl font-black text-blackHighEmphasis md:text-4xl md:leading-[1.4]`}
                        style={{ '--reveal-delay': '80ms' } as React.CSSProperties}>
                        قبل از دانلود اپلیکیشن ازکی‌سرویس
                    </h2>
                    <p
                        data-reveal
                        className={`${classes.reveal} mt-4 text-sm leading-8 text-blackMediumEmphasis md:text-base`}
                        style={{ '--reveal-delay': '160ms' } as React.CSSProperties}>
                        پاسخ سوال‌های رایج درباره نصب اپ، نسخه iOS، خدمات در محل و روش‌های پرداخت.
                    </p>
                </div>

                <div className='mx-auto max-w-3xl'>
                    {FAQS.map((faq, idx) => (
                        <div
                            key={faq.id}
                            data-reveal
                            className={`${classes.reveal} mb-4`}
                            style={{ '--reveal-delay': `${idx * 60}ms` } as React.CSSProperties}>
                            <Accordion
                                typographyProps={{ variant: 'subtitle2', component: 'h3' }}
                                accordionShadow='elevation1'
                                accordionSummery={faq.question}
                                component='div'>
                                <Typography variant='caption' component='p' className='leading-7 text-blackMediumEmphasis'>
                                    {faq.answer}
                                </Typography>
                            </Accordion>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Faq;
